<div class="subscription-result-container">
  @if (status === "success") {
    <div class="result-card success">
      <div class="icon">✓</div>

      <h2>Subscription Activated</h2>

      <p>
        Your subscription has been successfully activated. You now have access
        to premium features.
      </p>

      <button type="button" class="action-btn" (click)="redirectTo()">
        Go to Profile
      </button>
    </div>
  }

  @if (status === "failure") {
    <div class="result-card failure">
      <div class="icon">✕</div>

      <h2>Payment Failed</h2>

      <p>
        We couldn't process your payment. Please try again or use a different
        payment method.
      </p>

      <button type="button" class="action-btn" (click)="redirectTo()">
        Back to Profile
      </button>
    </div>
  }

  @if (status === "cancel") {
    <div class="result-card cancel">
      <div class="icon">!</div>

      <h2>Checkout Cancelled</h2>

      <p>You cancelled the checkout process. No payment has been charged.</p>

      <button type="button" class="action-btn" (click)="redirectTo()">
        Back to Profile
      </button>
    </div>
  }
</div>
